import R from 'ramda'

const OPT_IN_ACTION_TYPE = 'OPT_IN'
const OPT_IN_DISPLAY_TYPE = 'Opt user in'

const isOptInWidgetAction = R.propEq('type', OPT_IN_ACTION_TYPE)

const convertOptInWidgetActionToFormAction = R.applySpec({
  type: R.always(OPT_IN_DISPLAY_TYPE)
})

export { isOptInWidgetAction, convertOptInWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/opt-in.js